import DOMPurify from 'dompurify';

function bytesToSize(bytes) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

function getInnerHTMLFormat(value) {
  return {
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(value)
    }
  };
}

const handleKeyDown = (e, cb) => {
  if (e.key === 'Enter' && e.shiftKey === false) {
    e.preventDefault();
    cb();
  }
};

export {
  bytesToSize,
  getInnerHTMLFormat,
  handleKeyDown,
}



// WEBPACK FOOTER //
// ./src/helpers/utils.js